var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-date-picker',{staticClass:"mt-4",attrs:{"color":"primary","allowed-dates":_vm.allowedDates,"min":"2016-06-15","max":"2018-03-20"},model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}})}
var staticRenderFns = []

export { render, staticRenderFns }